import angular from 'angular';
import portaro from '../portaro';
import TabSystem from './tab-system';
import {DatasourceGroup, Kind, SearchType} from '../commons/constants/portaro.constants';
import {getUrlParams} from 'shared/utils/url-utils';
import {deepFreeze} from 'shared/utils/custom-utils';
import {getRecordPath, getRecordUrlId, responseToData} from 'shared/utils/data-service-utils';
import KpCover from './kp-cover/KpCover.svelte';
import KpDocumentMini from './kp-document-mini/KpDocumentMini.svelte';
import KpVisitedPanel from '../commons/components/kp-visited-panel/KpVisitedPanel.svelte'
import {DocumentInterceptorRegistrar} from './document.interceptor-registrar';
import KpAvailabilityInfo from './kp-availability-info/KpAvailabilityInfo.svelte';
import KpFavouritesPanel from '../commons/components/kp-favourites-panel/KpFavouritesPanel.svelte';
import KpCollectionSingleInsertButton
    from '../commons/components/kp-record-collection-single-insert-button/KpCollectionSingleInsertButton.svelte';
import Pagination from '../search/pagination';
import KpCitation from './kp-citation/KpCitation.svelte';
import KpRecordDetailTable from '../commons/components/kp-record-detail-table/KpRecordDetailTable.svelte';

const DEFAULT_TAB_PRIORITIES = deepFreeze({
    EXEMPLARS: 800,
    ARTICLES: 700,
    PARTS: 600,
    CITATION: 500,
    NONE: 400,
    TOC: 300,
    DETAIL: 200,
    MARC: 100,
    LOANS: 80,
    OPERATIONS: 60
});

portaro.controller('DocumentCtrl', ['$scope', '$http', '$q', 'CONTEXT_PATH', 'fileUploadService', 'reloader', 'currentAuth', 'currentDepartment', 'exemplarService', 'directoryDataService', 'availabilityDataService', 'loanRequestService', '$window', 'searchService', 'searchManagerFactory', 'finishedResponseInteractionService', 'modalConversationService', 'recordService', 'recordDataService', 'modalConversationInterceptor',
    function (/*IScope*/ $scope,
              /*IHttpService*/ $http,
              /*IQService*/ $q,
              /*string*/ CONTEXT_PATH,
              /*FileUploadService*/ fileUploadService,
              /*ReloaderService*/ reloader,
              /*Auth*/ currentAuth,
              /*Department*/ currentDepartment,
              /*ExemplarService*/ exemplarService,
              /*DirectoryDataService*/ directoryDataService,
              /*AvailabilityDataService*/ availabilityDataService,
              /*LoanRequestService*/ loanRequestService,
              /*IWindowService*/ $window,
              /*SearchService*/ searchService,
              /*SearchManagerFactory*/ searchManagerFactory,
              /*FinishedResponseInteractionService*/ finishedResponseInteractionService,
              /*ModalConversationService*/ modalConversationService,
              /*RecordService*/ recordService,
              /*RecordDataService*/ recordDataService,
              /*ModalConversationInterceptorService*/ modalConversationInterceptor) {

        $scope.CONTEXT_PATH = CONTEXT_PATH;
        $scope.currentAuth = currentAuth;
        $scope.$window = $window;
        $scope.kpCoverComponent = KpCover;
        $scope.kpDocumentMiniComponent = KpDocumentMini;
        $scope.kpVisitedPanelComponent = KpVisitedPanel;
        $scope.kpAvailabilityInfoComponent = KpAvailabilityInfo;
        $scope.kpFavouritesPanelComponent = KpFavouritesPanel;
        $scope.kpCollectionSingleInsertButton = KpCollectionSingleInsertButton;
        $scope.kpCitationComponent = KpCitation;
        $scope.kpRecordDetailTable = KpRecordDetailTable;


        $scope.init = function () {
            angular.extend($scope, window.model);
            new DocumentInterceptorRegistrar(modalConversationInterceptor).register();
            $scope.document = $scope.view.document;

            availabilityDataService.getByDocumentAndRequester($scope.document, currentAuth.activeUser.id)
                .then((av) => {
                    $scope.availability = av;
                    return av;
                });

            const PARTS_PAGE_SIZE = 5;
            $scope.partsPagination = Pagination.createWithNotPagedFunction($q, (pageNumber) => recordService.getAllRecordParts($scope.document, pageNumber, PARTS_PAGE_SIZE), PARTS_PAGE_SIZE);
            $scope.partsPagination.loadPage(1, null);

            const ARTICLES_PAGE_SIZE = 5;
            $scope.articlesPagination = Pagination.createWithNotPagedFunction($q, (pageNumber) => recordService.getAllRecordArticles($scope.document, pageNumber, ARTICLES_PAGE_SIZE), ARTICLES_PAGE_SIZE);
            $scope.articlesPagination.loadPage(1, null);

            recordService.getAllRecordHoldings($scope.document, currentDepartment)
                .then((recordHoldings) => {
                    $scope.recordHoldings = recordHoldings;
                    return recordHoldings;
                });

            $scope.navigationButtons = function (urlParams, currentId) {
                const current = currentId;
                const back = urlParams.back;
                const group = urlParams.group ? urlParams.group
                        .split(",")
                        .filter((idString) => idString.length > 0)
                    : null;

                function showAny() {
                    return !!(back || group);
                }

                function showBack() {
                    return !!back;
                }

                function getBackLink() {
                    return back;
                }

                function showPrevious() {
                    return group && group.indexOf(current) > 0;
                }

                function showNext() {
                    return group && group.indexOf(current) < group.length - 1;
                }

                function getPreviousPath() {
                    if (!showPrevious()) {
                        return "";
                    }
                    const currentId = group[group.indexOf(current) - 1];
                    return getRecordPath(currentId) + getUrlParams();
                }

                function getNextPath() {
                    if (!showNext()) {
                        return "";
                    }
                    const currentId = group[group.indexOf(current) + 1];
                    return getRecordPath(currentId) + getUrlParams();
                }

                function getUrlParams() {
                    let s = "";
                    if (back) {
                        s += "?";
                        s += "back=" + encodeURIComponent(back);
                    }
                    if (group) {
                        s += s.length > 0 ? "&" : "?";
                        s += "group=" + urlParams.group;
                    }
                    return s;
                }

                return {
                    showAny: showAny,
                    showBack: showBack,
                    showPrevious: showPrevious,
                    showNext: showNext,
                    getBackLink: getBackLink,
                    getPreviousPath: getPreviousPath,
                    getNextPath: getNextPath
                }
            }(getUrlParams(), getRecordUrlId($scope.document));

            $q.when($scope.document.$promise || $scope.document)
                .then(() => exemplarService.getExemplarList($scope.document, $scope.view.exemplarsView))
                .then((exemplarList) => $scope.exemplarList = exemplarList);

            if ($scope.document.directoryId) {
                directoryDataService.getInsight($scope.document.directoryId, $scope.document.cover ? $scope.document.cover.id : null)
                    .then((insight) => $scope.directoryInsight = insight);
            }


            $scope.loadLoans = function () {
                if (!$scope.loanListSearchManager) {
                    const staticParams = {
                        type: SearchType.TYPE_LOAN_SEARCH,
                        kind: Kind.KIND_LOAN,
                        record: [$scope.document.id],
                        loanState: ['ON_WAITING_LIST', 'UNSENT_RESERVATION', 'SENT_RESERVATION', 'UNPROCESSED_ORDER', 'PROCESSED_ORDER', 'LENT', 'RETURNED', 'CANCELLED_RESERVATION'],
                        pageSize: 10
                    };
                    $scope.loanListSearchManager = searchManagerFactory.createLocalSearch(searchService.search.bind(searchService), staticParams);
                    $scope.loanListSearchManager.newSearch();
                }
            };


            $scope.loadOperations = function () {
                if (!$scope.operationListSearchManager) {
                    const staticParams = {
                        type: SearchType.TYPE_RECORD_OPERATION_SEARCH,
                        kind: Kind.KIND_RECORD_OPERATION,
                        record: [$scope.document.id],
                        pageSize: 10
                    };
                    $scope.operationListSearchManager = searchManagerFactory.createLocalSearch(searchService.search.bind(searchService), staticParams);
                    $scope.operationListSearchManager.newSearch();
                }
            };
        };


        $scope.detailTabs = new TabSystem(Object.assign({}, DEFAULT_TAB_PRIORITIES, $window.documentTabPriorities));

        $scope.createExemplar = async () => {
            await exemplarService.createExemplarByFormAndReload($scope.document, null);
        }

        $scope.onCoverFileSelect = async function (files) {
            await fileUploadService.upload(`${CONTEXT_PATH}/api/records/${$scope.document.id}/covers/add`, files[0]);
            return reloader.reload();
        };

        $scope.showSendMailForm = async function () {
            try {
                const httpResponse = await $http.post(`${CONTEXT_PATH}/api/records/${$scope.document.id}/templated-mail`, {record: $scope.document.id});
                const actionResponse = responseToData(httpResponse);
                return finishedResponseInteractionService.showSuccessResponseInToastIfPossible(actionResponse);
            } catch (httpError) {
                const actionResponse = responseToData(httpError);
                return finishedResponseInteractionService.showFailedResponseInToast(actionResponse);
            }
        };

        $scope.requestDocument = async function () {
            try {
                const actionResponse = await loanRequestService.requestDocument($scope.document);
                await finishedResponseInteractionService.showSuccessResponseInToastIfPossible(actionResponse);
                reloader.reload(1000);
            } catch (exceptionResponse) {
                await finishedResponseInteractionService.showFailedResponseInModalWindow(exceptionResponse);
            }
        };

        $scope.copyRecord = async function() {
            await recordService.copyRecordToSpecifiedFondAndAddRecordHoldingThrowingToModal($scope.document);
        };

        $scope.updateWithExternalRecord = async function () {
            let initialFrontendParams = {};

            if ($scope.document.isbn) {
                initialFrontendParams.isbnOrIssn = $scope.document.isbn.value;
            } else {
                if ($scope.document.author) {
                    initialFrontendParams.author = $scope.document.author;
                }
                if ($scope.document.publicationYear) {
                    initialFrontendParams.publicationYear = $scope.document.publicationYear;
                }
                if ($scope.document.name) {
                    initialFrontendParams.name = $scope.document.name;
                }
            }

            const modalModel = {
                staticSearchParams: {
                    kind: Kind.KIND_DOCUMENT,
                    type: SearchType.TYPE_SEARCH_SELECTION,
                    datasourceGroup: DatasourceGroup.EXTERNAL
                },
                initialFrontendParams
            };

            await recordService.updateWithExternalRecordAndReloadThrowingToToast($scope.document, modalModel);
        }

        $scope.deleteRecordHolding = async function (recordHolding) {
            await recordService.deleteRecordHolding(recordHolding);
        };

        $scope.refresh = () => reloader.reload();
    }]);
